// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixWindow from 'wix-window';


$w.onReady(function () {


});

	

//export function image16_click(event, $w) {
//	wixWindow.openLightbox ("menu");
	//Add your code for this event here: 
	
//}

export function image16_mouseIn(event, $w) {
	wixWindow.openLightbox ("menu");
}

